import { CreateInvestmentInput } from "../../backend/generated/create-investment-input";
import { GetInvestmentInput } from "../../backend/generated/get-investment-input";
import { Investment } from "../../backend/generated/investment-model";
import { UpdateInvestmentInput } from "../../backend/generated/update-investment-input";
import { InvestmentStatusValues, ValidationMessages } from "../../backend/types/utils";
import { prune } from "../../utils/utility";
import { CustomValidationArguments, validateBooleansTrue, validateNumbersInRange, validateRequiredNotDefault } from "../../utils/validation";

export class InvestmentManageable extends Investment {
  constructor(obj: any) {
    super();

    obj && Object.assign(
      this,
      prune(obj),
      { status: obj.status ? obj.status.toLowerCase() as InvestmentStatusValues : obj.status }
    );

    const statusChangeLog = [];
    if (this.statusChangeLog) {
      for (let i = 0; i < this.statusChangeLog.length; i++) {
        statusChangeLog.push(this.statusChangeLog[i]);
      }
    }
    this.statusChangeLog = statusChangeLog;
  }

  static default(): any {
    return { ...new Investment() }
  }

  isRevocable(): boolean {
    return this.status === InvestmentStatusValues.AWAITING_PAYMENT;
  }
}

export class CreateInvestmentManageable extends CreateInvestmentInput {
  agreement1?: boolean;
  agreement2?: boolean;
  limitIncreased?: boolean;
  limitIncreasedBy?: number;
  maxAmount?: number;
  minAmount?: number;
  password?: string;
  termsEffectaGmbh?: boolean;
  termsFinproAG?: boolean;

  constructor(obj?: any) {
    super();
    if (obj) {
      obj && Object.assign(
        this,
        CreateInvestmentManageable.default(),
        prune(obj)
      );
    } else {
      Object.assign(
        this,
        CreateInvestmentManageable.default()
      );
    }
  }

  static required(): any {
    return {
      agreement1: true,
      agreement2: true,
      amountShares: true,
      termsEffectaGmbh: true,
      termsFinproAG: true,
      paymentId: true,
      password: true,
    }
  }

  static default(): any {
    return {
      ...new CreateInvestmentInput(),
      agreement1: false,
      agreement2: false,
      minAmount: 0,
      maxAmount: null,
      termsEffectaGmbh: false,
      termsFinproAG: false,
      limitIncreased: false,
      limitIncreasedBy: "",
      awareFees: true,
      password: "",
    }
  }

  validate(
    keys: Array<string>, messages: any
  ): any {
    let errors: any = {};

    errors = Object.assign(
      errors,
      validateBooleansTrue(new CustomValidationArguments({
        keys: ['termsEffectaGmbh', 'termsFinproAG', 'agreement1', 'agreement2'],
        errors,
        values: this,
        allowedKeys: keys,
        errorMessage: messages[ValidationMessages.REQUIRED]
      }))
    );

    validateRequiredNotDefault(
      errors,
      CreateInvestmentManageable.required(),
      this,
      CreateInvestmentManageable.default(),
      keys,
      messages[ValidationMessages.REQUIRED]
    );

    validateNumbersInRange(
      [{
        key: 'amountShares',
        min: this.minAmount,
        max: this.maxAmount,
      }],
      errors,
      this,
      keys,
      messages[ValidationMessages.MINIMUM],
      messages[ValidationMessages.MAXIMUM],
    );

    return errors;
  }

  serialize(): any {
    let data: any = Object.assign(
      {},
      this
    );

    data.tac =
      (data.termsEffectaGmbh ? Math.pow(
        2,
        0
      ) : 0) +
      (data.termsFinproAG ? Math.pow(
        2,
        1
      ) : 0)
    ;

    delete data.agreement1;
    delete data.agreement2;
    delete data.limitIncreased;
    delete data.limitIncreasedBy;
    delete data.maxAmount;
    delete data.minAmount;
    delete data.password;
    delete data.termsEffectaGmbh;
    delete data.termsFinproAG;

    return data;
  }
}

export class UpdateInvestmentManageable extends UpdateInvestmentInput {
  termsRevocation?: boolean;

  constructor(obj?: any) {
    super();
    if (obj) {
      obj && Object.assign(
        this,
        UpdateInvestmentManageable.default(),
        prune(obj)
      );
    } else {
      Object.assign(
        this,
        UpdateInvestmentManageable.default()
      );
    }
  }

  required(): any {
    return { termsRevocation: this.status === InvestmentStatusValues.REVOKE_REQUESTED }
  }

  static default(): any {
    return {
      ...new UpdateInvestmentInput(),
      termsRevocation: false,
    }
  }

  validate(
    keys: Array<string>, messages: any
  ): any {
    return validateRequiredNotDefault(
      {},
      this.required(),
      this,
      UpdateInvestmentManageable.default(),
      keys,
      messages[ValidationMessages.REQUIRED]
    );
  }

  serialize(): any {
    let data: any = Object.assign(
      {},
      this
    );

    if (data.status) {
      data.status = data.status.toUpperCase();
    }

    delete data.termsRevocation;

    return data;
  }
}

export class GetInvestmentManageable extends GetInvestmentInput {
  constructor(obj?: any) {
    super();
    if (obj) {
      obj && Object.assign(
        this,
        GetInvestmentManageable.default(),
        prune(obj)
      );
    } else {
      Object.assign(
        this,
        GetInvestmentManageable.default()
      );
    }
  }

  static required(): any {
    return { }
  }

  static default(): any {
    return { ...new GetInvestmentInput() }
  }

  validate(
    keys: Array<string>, messages: any
  ): any {
    return validateRequiredNotDefault(
      {},
      GetInvestmentManageable.required(),
      this,
      GetInvestmentManageable.default(),
      keys,
      messages[ValidationMessages.REQUIRED]
    );
  }

  serialize(): any {
    let data: any = Object.assign(
      {},
      this
    );

    if (data.status) {
      data.status = data.status.toUpperCase();
    }

    return data;
  }
}